import styled from "styled-components";

export const OverlayStyle = styled.div<{ opacity: number; zIndexValue: number }>`
position: fixed;
top: 0;
right: 0;
bottom: 0;
left: 0;
background-color: rgba(0, 0, 0, 0.5);
opacity: ${(props) => props.opacity};
z-index: ${(props) => props.zIndexValue};
`;
